import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell, Checkbox, TableSortLabel } from '@mui/material';
import M from 'messages';
import domainData from 'store/domainStore';
import { getCellPadding, getWidth } from 'helpers/tableStyleHelper';
import TableConfigs from 'constants/table-configs';

import classes from './styles';

function CustomTableHead(props) {
  const {
    handleAllSelected,
    sortObj,
    rowCount = 0,
    fields,
    withEditAction = true,
    withQRAction = false,
    withInMarketAction = false,
    withRemoveAction = false,
    withResponseAction = false,
    onRequestSort = null,
    filteredParams,
    withCheckbox = true,
    withOpenAction = false,
    withCloneAction = false,
    tableSelects = null,
    stickyHeader = false,
  } = props;

  const createSortHandler = property => event => {
    if (onRequestSort) {
      onRequestSort(event, property);
    }
  };

  const isUserSuperAdmin = domainData.userIsSuperAdmin();

  const currentSp = domainData.getCurrentSP();
  let ceilCount = 0;
  if (withQRAction) {
    ceilCount += 1;
  }
  if (withInMarketAction) {
    ceilCount += 1;
  }
  if (withEditAction) {
    ceilCount += 1;
  }
  if (withOpenAction) {
    ceilCount += 1;
  }
  if (withCloneAction) {
    ceilCount += 1;
  }
  if (withRemoveAction) {
    ceilCount += 1;
  }
  if (withResponseAction) {
    ceilCount += 1;
  }
  const drawActions = () =>
    Array.from({ length: ceilCount }, (_, i) => (
      <TableCell
        key={i}
        style={{
          width: '24px',
          paddingRight: i === ceilCount - 1 ? '32px' : '6px',
          paddingLeft: '6px',
        }}
      />
    ));
  return (
    <TableHead>
      <TableRow sx={classes.tableHeadRow}>
        {withCheckbox && (
          <TableCell padding="checkbox" style={{ width: '24px', paddingRight: '16px', paddingLeft: '24px' }}>
            <Checkbox
              indeterminate={tableSelects > 0 && tableSelects < rowCount}
              checked={rowCount > 0 && tableSelects === rowCount}
              onChange={handleAllSelected}
              color="primary"
            />
          </TableCell>
        )}
        {fields.map(headCell => {
          const id = headCell.orderField || headCell.id;
          const { cellPaddingRight, cellPaddingLeft } =
            rowCount > 0
              ? headCell
              : {
                  cellPaddingRight: TableConfigs.defaultCellPadding,
                  cellPaddingLeft: TableConfigs.defaultCellPadding,
                };
          return (
            (!headCell.show || headCell.show({ isUserSuperAdmin, currentSp })) && (
              <TableCell
                key={id}
                sortDirection={sortObj.field === id ? sortObj.order : false}
                style={{
                  ...getCellPadding(cellPaddingRight, cellPaddingLeft),
                  ...(stickyHeader ? { minWidth: headCell.minWidth } : getWidth(headCell.width)),
                }}
                align={headCell.headAlign || 'left'}>
                {headCell.sortable && (
                  <TableSortLabel
                    active={filteredParams?.params?.sort?.field === id}
                    direction={filteredParams?.params?.sort?.field === id ? filteredParams.params.sort.order : 'asc'}
                    onClick={createSortHandler(id)}>
                    {M.get(headCell.label)}
                  </TableSortLabel>
                )}
                {!headCell.sortable && M.get(headCell.label)}
              </TableCell>
            )
          );
        })}
        {drawActions()}
      </TableRow>
    </TableHead>
  );
}

CustomTableHead.propTypes = {
  onRequestSort: PropTypes.func,
  handleAllSelected: PropTypes.func.isRequired,
  sortObj: PropTypes.shape({
    order: PropTypes.oneOf(['asc', 'desc', '']),
    field: PropTypes.string,
  }).isRequired,
  rowCount: PropTypes.number,
  fields: PropTypes.instanceOf(Array).isRequired,
  filteredParams: PropTypes.instanceOf(Object).isRequired,
  withEditAction: PropTypes.bool,
  withRemoveAction: PropTypes.bool,
  withCheckbox: PropTypes.bool,
  withOpenAction: PropTypes.bool,
  withCloneAction: PropTypes.bool,
  tableSelects: PropTypes.number,
  withQRAction: PropTypes.bool,
  withInMarketAction: PropTypes.bool,
  withResponseAction: PropTypes.bool,
  stickyHeader: PropTypes.bool,
};

export default CustomTableHead;
